import ApiRequest from './ApiRequest';

export default {
    get(key, cb) {
        let localKey = `${key}_${window.configVersion}`;
        let item = localStorage ? localStorage.getItem(localKey) : null;
        if (item) {
            cb(JSON.parse(item));
        } else {
            let request = new ApiRequest();
            request.get(`config/${key}?key=${window.configVersion}`, {}, (err, res) => {
                if (res && res.body && res.body.data) {
                    if (localStorage) {
                        try {
                            if (localStorage.getItem('configVersion') !== window.configVersion) {
                                localStorage.clear();
                                localStorage.setItem('configVersion', window.configVersion);
                            }

                            localStorage.setItem(localKey, JSON.stringify(res.body.data));
                        } catch (e) {
                            Bugsnag.notify('Anyone - SiteConfig@get:', 'Config localStorage error', { e });
                        }
                    }
                    cb(res.body.data);
                }
            });
        }
    }
};